import { FileClockIcon, NoteIcon } from '@sharedCR/coreDesignSystem/icons';

import { getRecipientCopyLabel } from 'utils/documents';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';

import {
  PREVIEW_RECIPIENT_COPY_HEADER,
  PREVIEW_RECIPIENT_COPY_NOTICE,
  PREVIEW_RECIPIENT_COPY_TITLE,
  VIEW_RECIPIENT_COPY_TITLE,
} from './DisclosureRecipientCopyButton.constants';

const getLabelWithSigner = (title, signerFullName) =>
  signerFullName ? `${title}: ${signerFullName}` : title;

const getRecipientCopyButtonAriaLabel = signerFullName =>
  getLabelWithSigner(VIEW_RECIPIENT_COPY_TITLE, signerFullName);

const getRecipientPreviewButtonAriaLabel = signerFullName =>
  getLabelWithSigner(PREVIEW_RECIPIENT_COPY_TITLE, signerFullName);

const getRecipientPreviewHeader = signerFullName =>
  getLabelWithSigner(PREVIEW_RECIPIENT_COPY_HEADER, signerFullName);

export const getRecipientCopyFileName = ({ formBundleName, signerFullName }) =>
  [formBundleName, signerFullName].filter(Boolean).join(' ');

export const getRecipientCopyButtonConfig = ({ isPreview, recipientRequestId, signerFullName }) =>
  isPreview
    ? {
        ariaLabel: getRecipientPreviewButtonAriaLabel(signerFullName),
        dataTestId: DisclosureDeliveryTestIds.getRecipientPreviewButtonId(recipientRequestId),
        header: getRecipientPreviewHeader(signerFullName),
        icon: FileClockIcon,
        isDownloadable: false,
        isPrintable: false,
        notice: PREVIEW_RECIPIENT_COPY_NOTICE,
        title: PREVIEW_RECIPIENT_COPY_TITLE,
      }
    : {
        ariaLabel: getRecipientCopyButtonAriaLabel(signerFullName),
        dataTestId: DisclosureDeliveryTestIds.getRecipientCopyButtonId(recipientRequestId),
        header: getRecipientCopyLabel(signerFullName),
        icon: NoteIcon,
        isDownloadable: true,
        isPrintable: true,
        notice: null,
        title: VIEW_RECIPIENT_COPY_TITLE,
      };
